"use client";

import { useQuery } from "@tanstack/react-query";
import { type Address, erc20Abi } from "viem";

import { readContract } from "#/services/blockchain/blockchain.service";

export const useApproval = ({
  amount,
  spender,
  tokenAddress,
  account,
  chainId,
}: {
  amount?: bigint;
  spender: Address | undefined;
  tokenAddress: Address | undefined;
  account: Address | undefined;
  chainId?: number | string;
}) => {
  const {
    data: allowance,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [
      "readContract",
      "allowance",
      tokenAddress,
      spender,
      account,
      chainId,
    ],
    enabled: Boolean(account && spender && tokenAddress),
    queryFn: async () => {
      const spenderAllowance = await readContract(
        {
          abi: erc20Abi,
          address: tokenAddress!,
          functionName: "allowance",
          args: [account!, spender!],
        },
        chainId,
      );
      return BigInt(spenderAllowance);
    },
  });

  const isAllowanceSufficient =
    !amount || (allowance !== undefined && allowance >= amount);

  return {
    isLoading,
    isAllowanceSufficient,
    allowance,
    refetch,
  };
};
